import {
  ELECTRICITY_QUERY_KEY,
  SCHEDULE_QUERY_KEY,
  useSubmitScheduleMutation
} from '@domain/schedule'
import {useUpmPlantContext} from '@hconnect/upm'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

import {
  SCHEDULE_COST_AVOIDANCE_QUERY_KEY,
  fetchScheduleCostAvoidance
} from './useScheduleCostAvoidanceQuery'

export const useSubmitSchedule = (openCostAvoidanceDialog?: () => void) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {plantId: plantCode} = useUpmPlantContext()
  const queryClient = useQueryClient()
  return useSubmitScheduleMutation({
    onError: (error) => {
      const detail = (error.response?.data as {detail?: string} | undefined)?.detail
      if (detail) {
        spawnErrorToast(detail)
      }
    },
    onSuccess: async ({scheduleId}) => {
      spawnSuccessToast(t('success.planSubmit'))
      await queryClient.fetchQuery({
        queryKey: [SCHEDULE_COST_AVOIDANCE_QUERY_KEY, {plantCode, scheduleId}],
        queryFn: ({signal}) => fetchScheduleCostAvoidance(plantCode, scheduleId, signal)
      })
      openCostAvoidanceDialog?.()
    },
    onSettled: (data, error, {plantCode}) => {
      void queryClient.invalidateQueries({
        queryKey: [ELECTRICITY_QUERY_KEY, {plantCode}],
        refetchType: 'all'
      })
      void queryClient.invalidateQueries({queryKey: [SCHEDULE_QUERY_KEY], refetchType: 'all'})
    }
  })
}
